import React, { useState } from 'react';
import styles from './chat-bubble.module.scss';
import { AssistantChatInput } from '../.././assistant-chat-input/AssistantChatInput';
import piEditorStyles from '../pi-editor-content.module.scss';
import { BodyText, Icon } from '@placer-ui/components';
import classNames from 'classnames';

type ChatBubbleProps = {
    text: string;
    timestampText?: string;
    onClickTrashIcon?: (e: React.MouseEvent<HTMLButtonElement>) => Promise<void>;
    additionalContainerClassName?: string;
    textEditorContentClassName?: string;
};
export const ChatBubble = ({
    text,
    timestampText,
    onClickTrashIcon,
    additionalContainerClassName,
    textEditorContentClassName,
}: ChatBubbleProps) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <div
            className={classNames(styles.container, additionalContainerClassName)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            data-testid="chat-bubble"
        >
            <AssistantChatInput
                content={text}
                isReadOnly={true}
                textEditorContent={textEditorContentClassName ?? piEditorStyles.textEditorContent}
            />
            {(timestampText || onClickTrashIcon) && (
                <div className={styles.bubbleInfo}>
                    {timestampText && (
                        <span
                            className={styles.timeStepText}
                            aria-hidden={isHovered}
                            data-testid="timestamp-text"
                        >
                            <BodyText variant={'semi-bold'} size={'small'}>
                                {timestampText}
                            </BodyText>
                        </span>
                    )}
                    {onClickTrashIcon && (
                        <button
                            className={styles.trashIcon}
                            onClick={onClickTrashIcon}
                            aria-hidden={!isHovered}
                            data-testId={'trash-icon-button'}
                            aria-label={'delete conversation'}
                        >
                            <Icon type={'Trash'} size={24} color={'gray'} />
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};
